require('./dist/link/link.css');
